var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-global-audio-player"},[_c('span',[_vm._v("Audio: Total duration: "+_vm._s(_vm.duration)+" seconds")]),_vm._v(" | "+_vm._s(_vm.playing ? "Pause" : "Play")+" | "+_vm._s(_vm.volume)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }